import axios from 'axios';
import tokenStorage from '@/helpers/tokenStorage';
import { handleTokenRequest, logoutUser as SSOLogout } from '@/modules/sso/helpers';
import store from '../store';

const { NODE_ENV } = process.env;
let subscribers = [];
let retryRefreshToken = false;
let retrying = false;

const onAccessTokenFetched = (access_token) => {
  subscribers = subscribers.filter(callback => callback(access_token));
};

const addSubscriber = (callback) => {
  subscribers.push(callback);
};

function logoutUser() {
  tokenStorage.destroy();
  localStorage.removeItem('account');
  localStorage.removeItem('account_token');
  document.cookie = 'cache_counter=; Max-Age=0';

  SSOLogout(window.location.href);
}

export default async (error) => {
  const { config, response: { status } } = error;
  const originalRequestConfig = config;

  if (status === 401) {
    if (!retryRefreshToken) {
      retryRefreshToken = true;

      const dispatchFunc = async () => {
        try {
          if (NODE_ENV === 'development') {
            const token = await store.dispatch('refreshToken');
            onAccessTokenFetched(token.access_token);
            retryRefreshToken = false;
            retrying = true;
          } else {
            const { refresh_token } = tokenStorage.get();
            await handleTokenRequest(refresh_token);
            const token = tokenStorage.get();
            if (token && token.access_token) {
              onAccessTokenFetched(token.access_token);
              retryRefreshToken = false;
              retrying = true;
            }
          }
        } catch (err) {
          logoutUser();
        }
      };

      dispatchFunc();
    } else {
      logoutUser();
    }

    return new Promise((resolve) => {
      addSubscriber((access_token) => {
        originalRequestConfig.headers.Authorization = `Bearer ${access_token}`;
        if (retrying) {
          // originalRequestConfig.baseURL = '';
          retrying = false;
        }
        resolve(axios(originalRequestConfig));
      });
    });
  }

  return Promise.reject(error);
};
